import { IAllDriverFactors } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { GET_ALL_DRIVER_FACTOR } from "../../routes";



const getAllDriverFactors = async (props: IAllDriverFactors) => {

  try {
    return (await customAxios.post(GET_ALL_DRIVER_FACTOR+"/"+props.driverId, {
      discount: props.discount,
      startAt : props.startAt ,
      endAt   : props.endAt   ,
    })).data;
  } catch (error: any) {
    console.log({ GET_ALL_SCHOOL: error });
  }
};

export default getAllDriverFactors;
